import {between, maxValue, minValue, numeric, required} from 'vuelidate/lib/validators';
import { EsalCalculationMethods } from '@/modules/design/interfaces/shared';
import { IConcreteDesignImperial } from '@/modules/design/interfaces/newConcrete';

export const createConcreteValidations = (scenario: IConcreteDesignImperial) => ({
    scenarioImperial: {
      // Page 1
      name: {
        required,
      },
      completionYear: {
        minValue: minValue(new Date(Date.now()).getFullYear() - 100),
        maxValue:
          maxValue(new Date(Date.now()).getFullYear() + 100),
      },
      roadwayClassification: {
        required,
      },

      state: {
        required,
      },

      // Page 2
      designPeriod_years: {
        required,
        minValue: minValue(0),
      },
      reliabilityLevel: {
        required,
      },
      standardError: {
        required,
        between: between(0, 1),
      },
      initialServiceability: {
        required,
        between: between(0, 5),
      },
      terminalServiceability: {
        required,
        between: between(0, 5),
      },
      meanWindSpeed_mph: {
        required,
        minValue: minValue(0),
      },
      meanPrecip_in: {
        required,
        minValue: minValue(0),
      },
      meanTemp_degF: {
        required,
        minValue: minValue(0),
      },


      // Page 3
      initialTraffic: {
        required,
        minValue: minValue(0),
      },
      loadEquivalencyFactor: {
        required,
        minValue: minValue(0),
      },
      esals: {
        required,
        minValue: minValue(0),
      },
      trafficGrowthRate: {
        required,
      },
      esalGrowthRate: {
        required,
      },
      totalDesignEsals: {
        required,
        minValue: minValue(0),
      },
      loadDiameter_in: {
        required,
        minValue: minValue(0),
      },


      // Page 4
      ruptureModulus_psi: {
        required,
        minValue: minValue(0),
      },
      elasticModulus_psi: {
        required,
        minValue: minValue(0),
      },
      poissonsRatio: {
        required,
        minValue: minValue(0),
      },
      jointSpacing_in: {
        required,
        minValue: minValue(0),
      },
      loadTransferCoefficient: {
        required,
        minValue: minValue(0),
      },
      edgeSupport: {
        required,
        minValue: minValue(0),
      },


      // Page 5
      baseModulus_psi: {
        required,
        minValue: minValue(0),
      },
      baseThickness_in: {
        required,
        minValue: minValue(0),
      },
      drainageFactor: {
        required,
        minValue: minValue(0),
      },
      slabFrictionCoefficient: {
        required,
        minValue: minValue(0),
      },
      subgradeReactionModulus_psiPerIn: {
        required,
        minValue: minValue(0),
      },


    },

    /*
    Top level validations - not on model directly
     */


    // Page 2
    deltaServiceability: {
      between: between(0, 5),
    },

    // Page 3
    aadtGroup: [
      'scenarioImperial.initialTraffic',
      'scenarioImperial.loadEquivalencyFactor',
      'scenarioImperial.esals',
      'scenarioImperial.trafficGrowthRate',
      'scenarioImperial.esalGrowthRate',
      'scenarioImperial.totalDesignEsals',
    ],
    annualEsalGroup: [
      'scenarioImperial.esals',
      'scenarioImperial.esalGrowthRate',
      'scenarioImperial.totalDesignEsals',
    ],
    designEsalGroup: [
      'scenarioImperial.totalDesignEsals',
    ],


    1: [
      'scenarioImperial.name',
      'scenarioImperial.completionYear',
      'scenarioImperial.roadwayClassification',
      'scenarioImperial.state',
    ],
    2: [
      'scenarioImperial.designPeriod_years',
      'scenarioImperial.reliabilityLevel',
      'scenarioImperial.standardError',
      'scenarioImperial.initialServiceability',
      'scenarioImperial.terminalServiceability',
      'deltaServiceability',
      'scenarioImperial.meanWindSpeed_mph',
      'scenarioImperial.meanPrecip_in',
      'scenarioImperial.meanTemp_degF',

    ],
    3: (function () {
      // Validate based on method of calculation and whether or not it's porous (extra param)

      if (scenario.esalCalculatedFrom === EsalCalculationMethods.aadt) {
        return [
          'scenarioImperial.initialTraffic',
          'scenarioImperial.loadEquivalencyFactor',
          'scenarioImperial.esals',
          'scenarioImperial.trafficGrowthRate',
          'scenarioImperial.esalGrowthRate',
          'scenarioImperial.totalDesignEsals',
        ];
      } if (scenario.esalCalculatedFrom === EsalCalculationMethods.annual) {
        return [
          'scenarioImperial.esals',
          'scenarioImperial.esalGrowthRate',
          'scenarioImperial.totalDesignEsals',
        ];
      } 
        return [
          'scenarioImperial.totalDesignEsals',
        ];
    }()),
    4: [
      'scenarioImperial.ruptureModulus_psi',
      'scenarioImperial.elasticModulus_psi',
      'scenarioImperial.poissonsRatio',
      'scenarioImperial.jointSpacing_in',
      'scenarioImperial.loadTransferCoefficient',
      'scenarioImperial.edgeSupport',
    ],
    5: [
      'scenarioImperial.baseModulus_psi',
      'scenarioImperial.baseThickness_in',
      'scenarioImperial.drainageFactor',
      'scenarioImperial.slabFrictionCoefficient',
      'scenarioImperial.subgradeReactionModulus_psiPerIn',
    ],
    6: [
      '1',
      '2',
      '3',
      '4',
      '5',
    ],


    // aadtGroupPorous: [
    //   'scenarioImperial.initialTraffic',
    //   'scenarioImperial.loadEquivalencyFactor',
    //   'scenarioImperial.esals',
    //   'scenarioImperial.trafficGrowthRate',
    //   'scenarioImperial.esalGrowthRate',
    //   'scenarioImperial.totalDesignEsals',
    //   'scenarioImperial.loadDiameter_in'
    // ],
    // annualEsalGroupPorous: [
    //   'scenarioImperial.esals',
    //   'scenarioImperial.esalGrowthRate',
    //   'scenarioImperial.totalDesignEsals',
    //   'scenarioImperial.loadDiameter_in'
    // ],
    // designEsalGroupPorous: [
    //   'scenarioImperial.totalDesignEsals',
    //   'scenarioImperial.loadDiameter_in'
    // ],

  });
